import * as CSS from 'csstype';
import {
  Theme as StyledSystemTheme
} from 'styled-system';

import breakpoints, { Breakpoints } from './breakpoints';
import colors, { Colors } from './colors';
import {
  alert,
  accordion,
  buttonSizes,
  buttons,
  featureGrid,
  quote,
  card,
  form,
  headings,
  hero,
  links,
  nav,
  paper,
  tileSizes,
  videoCarousel,
  videoPlayer,
  wave
} from './components';
import { HeadingsObject } from './components/headings';
import * as shared from './shared/index';
import { ComponentsType } from './index';
import fonts, { Fonts } from './fonts';
import keyframe from './keyframes';
import radii, { Radii } from './radii';
import shadows, { Shadows } from './shadows';
import space, { Spaces } from './space';
import typography, { TypographyObject } from './typography';
import zIndices, { ZIndices } from './z-indices';

export interface LucidTheme
  extends Fonts,
  Omit<
  StyledSystemTheme,
  | 'colors'
  | 'buttons'
  | 'fonts'
  | 'fontSizes'
  | 'fontWeights'
  | 'lineHeights'
  | 'letterSpacings'
  | 'radii'
  | 'shadows'
  >
{
  breakpoints: Breakpoints;
  colors: Colors;
  radii: Radii;
  shadows: Shadows;
  space: Spaces;
  zIndices: ZIndices;
  // keyframes
  keyframe: typeof keyframe;
  // shared css blocks
  shared: typeof shared;
  // components
  alert: typeof alert;
  accordion: Record<ComponentsType['Accordion']['Components'], Record<string, CSS.Properties | object | string | number>>;
  buttonSizes: typeof buttonSizes;
  buttons: typeof buttons;
  quote: typeof quote;
  card: typeof card;
  featureGrid: typeof featureGrid;
  form: typeof form;
  headings: HeadingsObject;
  hero: typeof hero;
  links: typeof links;
  nav: typeof nav;
  paper: typeof paper;
  tileSizes: typeof tileSizes;
  typography: TypographyObject;
  videoCarousel: typeof videoCarousel;
  videoPlayer: typeof videoPlayer;
  wave: typeof wave;
}

export const theme: LucidTheme = {
  ...fonts,
  breakpoints,
  colors,
  radii,
  shadows,
  space,
  zIndices,
  // keyframe
  keyframe,
  // shared
  shared,
  // components
  alert,
  accordion,
  buttonSizes,
  buttons,
  quote,
  card,
  featureGrid,
  form,
  headings,
  hero,
  links,
  nav,
  paper,
  tileSizes,
  typography,
  videoCarousel,
  videoPlayer,
  wave
};

export interface ThemeProps {
  /** The theme object with all available styles. */
  theme: LucidTheme;
}

export interface OptionalThemeProps {
  /** The theme object with all available styles. */
  theme?: LucidTheme;
}

export default theme;
